export const calculateAsPixels = (px: string | number) => {
  if (typeof px === 'number') {
    return px + 'px'
  }
  if (!isNaN(+px)) {
    return px + 'px'
  }
  return px
}
